import { type ReactElement } from 'react';
import { QrBatchesPage } from '@citibox-panel/lockers-operations';
import { UserMenu } from '@/features/user-menu';
import {
  downloadQrBatch,
  fetchQrBatchStats,
  fetchQrBatches,
  requestQrBatch,
} from '@/lib/apiClient';
import { resolveMarket, resolveMarketIndicator } from '@/lib/marketIndicator';
import { marketTimeZone } from '@/lib/marketTimeZone';
import { readRuntimeConfig } from '@/lib/runtimeConfig';
import { useSession } from '@/lib/session';

// Composition root for the LOCK1 QR generator, exactly as the other operations routes are for their
// screens: resolves the runtime config, picks the reads and writes, and keeps the module free of
// any apps/shell dependency.
export function QrBatchesRoute(): ReactElement {
  const { roleNames } = useSession();
  const config = readRuntimeConfig();
  const indicator = resolveMarketIndicator(config);

  return (
    <QrBatchesPage
      brandLabel={indicator.text}
      brandDegraded={indicator.degraded}
      headerEnd={<UserMenu roleNames={roleNames} />}
      timeZone={marketTimeZone(resolveMarket(config))}
      fetchQrBatches={fetchQrBatches}
      fetchQrBatchStats={fetchQrBatchStats}
      requestQrBatch={requestQrBatch}
      downloadQrBatch={downloadQrBatch}
    />
  );
}
